import axios from 'axios';
import { environment } from '../environments/environment';
import { RetailerClient } from '../models/RetailerClient';
import { ProductType } from '../pages/product-analyzer/Product';

/**
 * Get retailers' names by a list of clientIds
 * @param clientId
 * @param productType
 * @returns list of retailers' names
 */
export const getRetailerClientByClientId = async (
  clientIds: number[],
  productType: ProductType,
): Promise<RetailerClient[]> => {
  try {
    const { data } = await axios.post<RetailerClient[]>(
      `${environment.baseUrl}/external/retailer-clients?isExternal=false&productType=${productType}`, // Set to false for RI UI, default is true for admin UI app
      clientIds,
    );
    return data;
  } catch (err: any) {
    throw new Error(`An error has occurred: ${err.message}`);
  }
};
